'use client'
import Link from 'next/link'

export default function DealsAbout({ deals }) {
  const destCount = new Set(deals.map((d) => d.destination)).size
  const thisMonth = deals.length
  return (
    <section className="border-b border-gray-100 bg-blue-50/60 px-4 py-10">
      <div className="mx-auto max-w-2xl text-center">
        <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-blue-500">Why FairFares</p>
        <h2 className="text-xl font-bold text-gray-900">Built for travellers, not for margins</h2>
        <p className="mt-3 text-sm leading-relaxed text-gray-600">
          Built by a team obsessed with finding genuinely cheap flights. We scan 1,800+ routes around the
          clock so you don&apos;t have to.
        </p>
        <div className="mt-6 grid grid-cols-3 divide-x divide-blue-100 rounded-2xl border border-blue-100 bg-white shadow-sm">
          <div className="py-4 px-3">
            <p className="text-2xl font-extrabold text-blue-600">{thisMonth}+</p>
            <p className="mt-0.5 text-xs text-gray-500">deals this month</p>
          </div>
          <div className="py-4 px-3">
            <p className="text-2xl font-extrabold text-blue-600">{destCount}</p>
            <p className="mt-0.5 text-xs text-gray-500">destinations monitored</p>
          </div>
          <div className="py-4 px-3">
            <p className="text-2xl font-extrabold text-blue-600">€0</p>
            <p className="mt-0.5 text-xs text-gray-500">commission — always</p>
          </div>
        </div>
        <div className="mt-6 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <a
            href="https://t.me/fairfares"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-blue-200 bg-white px-4 py-1.5 text-sm font-semibold text-blue-600 shadow-sm transition-colors hover:bg-blue-50"
            onClick={() => window.plausible?.('TelegramChannelClick', { props: { source: 'about_section' } })}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.248-1.97 9.289c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L8.24 14.605l-2.95-.924c-.642-.2-.654-.642.136-.953l11.527-4.447c.535-.194 1.003.13.609.967z"/></svg>
            Telegram channel
            <span className="bg-green-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full leading-none">New</span>
          </a>
        </div>
      </div>
    </section>
  )
}
